export default __webpack_public_path__ + "static/media/apple.3b2e07ad.svg";